import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import AddRoleBasicInformation from "./AddRoleBasicInformation";
import { RoleAPI } from "api";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

const schema = yup.object({
  name: yup.string().required("Name is required"),
  status: yup.boolean(),
  permissions: yup
    .array()
    .of(
      yup.object({
        roleId: yup.number(),
        menuId: yup.number(),
        allowView: yup.boolean(),
        allowDelete: yup.boolean(),
        allowUpdate: yup.boolean(),
        allowNew: yup.boolean(),
      }),
    )
    .required(),
});

const AddRole = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset, setValue } = methods;

  const onSubmit = async (data) => {
    let myData = {
      ...data,
      id: location?.state?.id ?? 0, // Use nullish coalescing to handle undefined or null
    };

    // console.log(myData);

    try {
      if (location?.state) {
        setLoading(true);
        await RoleAPI.post(myData);
        setLoading(false);
        toast.success("User role updated successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      } else {
        setLoading(true);
        await RoleAPI.post(myData);
        setLoading(false);
        toast.success("User role created successfully", {
          position: customSettings.toastPosition,
          autoClose: customSettings.toastClose,
        });
      }

      // ------- Get all object keys form data and set empty values to reset ------------
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = "";
      }
      reset({ ...submittedValues });
      navigate(-1);
    } catch (error) {
      toast.error("Something went wrong", {
        position: customSettings.toastPosition,
        autoClose: customSettings.toastClose,
      });
      console.log(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      reset(location.state);
    }
  }, [setValue]);

  return (
    <>
      {/* <PageTitle name="Users" />
      <div className="py-2">
        <BreadCrumb />
      </div> */}

      <PageTitle name="Administration | Roles" />

      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Header className="border-bottom">
              <Row className="flex-between-center ">
                <Col md>
                  {/* <h5 className="fs-9 text-nowrap mb-2 mb-md-0">
                    {" "}
                    Administration | Roles
                  </h5> */}
                  <BreadCrumbTable
                    title="Administration"
                    subTitle="Roles"
                    subSubTitle={location?.state?.name}
                  />
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    Ok
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <AddRoleBasicInformation />
          </Card>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddRole;
